<script>
import i18n from "@/plugins/i18n";
import { mapActions } from 'vuex';
import SwitchButton from "../../../components/SwitchButton.vue";

export default {
    components: {
        SwitchButton
    },

    data() {
        return {
            localeName: "surveys.revised_surveys",

            surveyLoading: false,
            surveySending: false,

            surveyDetails: null,
            surveyEndDate: null,

            moreOptions: false,
            deleteValidation: false,
            completeValidation: false,

            surveyParticipations: [],
            surveyParticipationInfo: {},
            loadingParticipants: false,
            currentPagination: 1,

            sendingToNewUsers: false,
            sentToNewUsers: false,

            sortBy: null,
            sortIncreasing: null,
            searchKeyword: null,

            sendButtonDisabled: false,
        }
    },

    computed: {
        todaysDate() {
            const today = new Date().toISOString().split('T')[0];
            return today;
        },

        isSurveyDone() {
            if (this.surveyDetails == null) {
                return false;
            }

            if (this.surveyDetails.is_send == true) {
                return this.surveyDetails.is_completed;
            } else {
                return false;
            }
        },

        unsentUserExists() {
            if (!this.surveyDetails || this.surveyDetails.is_send === false || this.sentToNewUsers == true) {
                return false;
            }

            return this.surveyParticipations.some(item => item.is_sent === false);
        },

        reminderOptions() {
            return [
                {val: 3, text: i18n.t("surveys.others.reminder_opt1")},
                {val: 5, text: i18n.t("surveys.others.reminder_opt2")},
                {val: 7, text: i18n.t("surveys.others.reminder_opt3")}
            ];
        },

        updateSurveyFields() {
            const admin_only = this.$user.role_id === 1 ? 
                [
                    { col: "is_completed", flag: "is_completed" }
                ] : 
                [];

            return [
                { col: "su1_survey_name", flag: "name" },
                { col: "su1_s_description", flag: "description" },
                { col: "reminder_frequency_day", flag: "reminder_frequency" },
                { col: "end_date", flag: "date" },
                ...admin_only
            ];
        },

        participationsHeaders() {
            return [
                {sortable: true, val: "firstname", text: i18n.t(`${this.localeName}.stakeholders.name`), width: "12.5%"},
                {sortable: true, val: "surname", text: i18n.t(`${this.localeName}.stakeholders.surname`), width: "12.5%"},
                {sortable: true, val: "email", text: i18n.t(`${this.localeName}.stakeholders.email`), width: "17.5%"},
                {sortable: true, val: "user_department_name", text: i18n.t(`${this.localeName}.stakeholders.department`), width: "15%"},
                {sortable: true, val: "role_name", text: i18n.t(`${this.localeName}.stakeholders.role`), width: "15%"},
                {sortable: false, val: "receives", text: i18n.t(`${this.localeName}.stakeholders.receives`), width: "10%"},
                {sortable: false, val: "survey_link", text: i18n.t(`${this.localeName}.stakeholders.link`), width: "10%"},
            ];
        }
    },

    async mounted() {
        await this._getSU1Details();
    },

    methods: {
        ...mapActions("surveys", [
            "getSU1Details",
            "updateSurveySU1",
            "completeSU1",
            "sendSurveySU1",
            "sendReminderSU1",
            "deleteSurveySU1",
            "getSU1Participation",
            "updateSU1Participation",
            "sendSu1ToNonReceivers",
            "downloadSu1Participants"
        ]),

        async _getSU1Details() {
            await this.setSurveyLoading(true);
            const params = {
                su1_survey_id: Number(this.$route.query["s"])
            }

            await this.getSU1Details(params)
                .then( async (res) => {
                    await this.formatEndDate(res.data.survey_details.end_date);
                    this.surveyDetails = res.data.survey_details;
                    await this._getSU1Participation();
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.message);
                })
                .finally(async () => {
                    await this.setSurveyLoading(false);
                })
        },

        async _updateSurvey(flag) {
            let params = {
                su1_survey_id: this.surveyDetails.su1_survey_id,
                body: {
                    updated_by: this.$user.user_id
                }
            }

            if (flag && flag != "date") {
                const col = this.updateSurveyFields.find(item => item.flag == flag).col;
                params.body[col] = this.surveyDetails[col];
            } else if (flag == "date") {
                params.body["end_date"] = await this.reformatEndDate(this.surveyEndDate);
            }

            await this.updateSurveySU1(params)
                .then( res => {
                    this.$notify("success", res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify("error", response.data.messageName);
                })
        },

        async handleConfirmComplete() {
            await this._completeSU1();               
            await this.resetMoreOptions();             
        },

        async _completeSU1() {
            const params = {
                survey_id: this.surveyDetails.su1_survey_id,
                body: {
                    updated_by: this.$user.user_id,
                    is_completed: true
                }
            }

            await this.completeSU1(params)
                .then( res => {
                    this.surveyDetails.is_completed = true;
                    this.$notify("success", res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify("error", response.data.messageName);
                })
        },

        async _sendSurveySU1() {
            if (this.sendButtonDisabled) 
                return;
            
            this.sendButtonDisabled = true;

            const params = {
                company_id: this.$user.company_id,
                created_by: this.$user.user_id,
                su1_survey_id: this.surveyDetails.su1_survey_id,
                survey_token: this.surveyDetails.survey_token
            };

            await this.setSurveySending(true);
            await this.sendSurveySU1(params)
                .then( async res => {
                    await this._getSU1Participation();
                    this.surveyDetails.is_send = true;
                    this.$notify("success", res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify("error", response.data.messageName);
                })
                .finally(async () => {
                    this.setSurveySending(false);
                    
                    setTimeout(()=>{
                        this.sendButtonDisabled = false;
                    } , 60000);
                })
        },

        async _sendReminderSU1() {
            if (this.sendButtonDisabled) 
                return;
            
            this.sendButtonDisabled = true;
            
            const params = {
                company_id: this.$user.company_id,
                created_by: this.$user.user_id,
                su1_survey_id: this.surveyDetails.su1_survey_id,
                survey_token: this.surveyDetails.survey_token
            }

            await this.setSurveySending(true);
            await this.sendReminderSU1(params)
                .then(async (res) => {
                    await this._getSU1Participation();
                    this.$notify("success", res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify("error", response.data.messageName);
                })
                .finally(async () => {
                    this.setSurveySending(false);
                    
                    setTimeout(()=>{
                        this.sendButtonDisabled = false;
                    } , 60000);
                });
        },

        async _deleteSurveySU1() {
            const params = {
                su1_survey_id: this.surveyDetails.su1_survey_id
            }

            await this.deleteSurveySU1(params)
                .then( res => {
                    this.$notify("success", res.data.messageName);
                    setTimeout(() => {
                        this.handleClickBack();
                    }, 300);
                })
                .catch(({ response }) => {
                    this.$notify("error", response.data.messageName);
                })
        },

        async handleConfirmDelete() {
                await this._deleteSurveySU1();
                await this.resetMoreOptions();             
        },

        async _getSU1Participation() {
            const params = {
                su1_survey_id: this.surveyDetails.su1_survey_id,
                page: this.currentPagination,
                sort_by: this.sortBy,
                sort_increasing: this.sortIncreasing,
                search_keyword: this.searchKeyword,
                is_deleted: false
            }

            await this.setLoadingParticipants(true);
            await this.getSU1Participation(params)
                .then( async (res) => {
                    const participations = res.data.participations;
                    this.surveyParticipations = participations;

                    if (res.data.participation_info.fetched_all == true) {
                        await this.handlePaginationEnd();
                    }

                    this.surveyParticipationInfo = res.data.participation_info;
                })
                .finally(async () => {
                    await this.setLoadingParticipants(false);
                })
        },

        async _updateSU1Participation(event, item) {
            const params = {
                su1_survey_participation_id: item.su1_survey_participation_id,
                receive_survey_link: event,
                updated_by: this.$user.user_id
            }

            this.updateSU1Participation(params)
                .then(res => {
                    item.receive_survey_link = event;
                    this.$notify("success", res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify("error", response.data.messageName);
                })
        },

        async _sendSu1ToNonReceivers() {
            const params = {
                created_by: this.$user.user_id,
                company_id: this.$user.company_id,
                survey_token: this.surveyDetails.survey_token,
                su1_survey_id: this.surveyDetails.su1_survey_id
            }

            await this.setSendingToNewUsers(true);
            await this.sendSu1ToNonReceivers(params)
                .then( async (res) => {
                    await this._getSU1Participation();
                    await this.setSentToNewUsers(true);
                    this.$notify("success", res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify("error", response.data.messageName);
                })
                .finally(async () => {
                    await this.setSendingToNewUsers(false);
                })
        },

        async _downloadSu1Participants() {
            const params = {
                su1_survey_id: this.surveyDetails.su1_survey_id,
                is_deleted: false
            }

            this.downloadSu1Participants(params)
                .then(res => {
                    const url = URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement("a");
                    link.href = url;

                    const name = String(localStorage.getItem("lang"))
                        .toLocaleLowerCase()
                        .includes("tr") ? "SKA Anketi Katılımcıları" : "SDG Survey Participants";
                    link.setAttribute(
                        "download",
                        `${name}.xlsx`
                    );
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(({ response }) => {
                    this.$notify("error", response.data.messageName);
                })
        },

        // handlers //

        async handleClickBack() {
            this.$router.push("/sdg-alignment-surveys");
        },
        
        async handleLoadMore() {
            await this.increasePagination();
            await this._getSU1Participation();
        },

        async handlePaginationEnd() {
            if (this.currentPagination != 1) {
                await this.decreasePagination();
            }
        },

        async copyToClipboard(item) {
            await navigator.clipboard.writeText(item.survey_link);
            this.$toast.open(
                {
                    message: i18n.t(`${this.localeName}.misc.copied`),
                    duration: 2000,
                    dismissable: true,
                    type: "success"
                }
            )
        },

        async handleClickSorter(item) {
            if (item.sortable == false) return;

            if (item.val == this.sortBy) {
                await this.setSortIncreasing(!this.sortIncreasing);
            } else {
                await this.setSortIncreasing(true);
            }
            await this.setSortBy(item.val);
            await this._getSU1Participation();
        },

        async handleClickReset() {
            await this.resetSorter();
            await this._getSU1Participation();
        },

        // setters //

        async setSurveyLoading(bool) {
            this.surveyLoading = bool;
        },

        async setSurveySending(bool) {
            this.surveySending = bool;
        },

        setMoreOptions() {
            this.setDeleteValidation(false);
            this.setCompleteValidation(false);
            this.moreOptions = !this.moreOptions;
        },

        resetMoreOptions() {
            this.moreOptions = false;
            this.setDeleteValidation(false);
            this.setCompleteValidation(false);
        },

        setDeleteValidation(bool) {
            this.deleteValidation = bool;
        },

        setCompleteValidation(bool) {
            this.completeValidation = bool;
        },

        async setLoadingParticipants(bool) {
            this.loadingParticipants = bool;
        },

        async setSentToNewUsers(bool) {
            this.sentToNewUsers = bool;
        },

        async setSendingToNewUsers(bool) {
            this.sendingToNewUsers = bool;
        },

        async increasePagination() {
            this.currentPagination ++;
        },

        async decreasePagination() {
            this.currentPagination --;
        },

        async setSortBy(item) {
            this.sortBy = item;
        },

        async setSortIncreasing(bool) {
            this.sortIncreasing = bool;
        },

        async resetSorter() {
            this.sortBy = null;
            this.sortIncreasing = null;
            this.searchKeyword = null;
        },

        // utils //

        async formatEndDate(endDate) {
            const date = new Date(endDate);
            this.surveyEndDate = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
        },

        async reformatEndDate(endDate) {
            const [yyyy, mm, dd] = endDate.split('-');
            const dateObj = new Date(`${yyyy}-${mm}-${dd}`);
            const currentDate = new Date();
            dateObj.setHours(currentDate.getHours());
            dateObj.setMinutes(currentDate.getMinutes());
            dateObj.setSeconds(currentDate.getSeconds());
            const formattedTime = `${('0' + dateObj.getHours()).slice(-2)}:${('0' + dateObj.getMinutes()).slice(-2)}:${('0' + dateObj.getSeconds()).slice(-2)}`;
            const backendDate = `${yyyy}-${mm}-${dd} ${formattedTime}`;
            return backendDate;
        }
    }
}
</script>

<template>
    <div class="survey-details-page flex-all-centered-col">
        <div class="loading-wrapper flex-all-centered-col" v-if="surveyLoading">
            {{ $t(`${localeName}.misc.loading`) }} ...
        </div>
        <div class="loading-wrapper flex-all-centered-col" v-if="!surveyLoading">
            <div class="top-buttons flex-all-centered-row">
                <button id="back-btn" @click="handleClickBack()">
                    <i class="fa-solid fa-caret-left"></i>
                    {{ $t(`${localeName}.buttons.back`) }}
                </button>

                <div class="more-btn-ctr">
                    <button id="more-btn" @click="setMoreOptions" @keydown.enter="setMoreOptions" @keydown.esc="resetMoreOptions">
                        <i class="fa-solid fa-ellipsis"></i>
                    </button>

                    <div class="actions-list flex-all-centered-col" v-if="moreOptions && !(deleteValidation || completeValidation)">
                        <div class="action-item flex-all-centered-row" tabindex="0"
                            @click="setDeleteValidation(true)" @keydown.enter="setDeleteValidation(true)"
                        >
                            <i class="fa-regular fa-trash-can"></i>
                            {{ $t(`${localeName}.buttons.delete`) }}
                        </div>
                        <div class="action-item flex-all-centered-row" tabindex="0"
                            @click="setCompleteValidation(true)" @keydown.enter="setCompleteValidation(true)"
                        >
                            <i class="fa-regular fa-circle-check"></i>
                            {{ $t(`${localeName}.buttons.complete`) }}
                        </div>
                    </div>
                    <div class="validation-message" v-else-if="moreOptions && (deleteValidation || completeValidation)">
                        <div class="message flex-all-centered-col" v-if="deleteValidation">
                            <div class="text">
                                {{ $t(`${localeName}.misc.delete_validation`) }}
                            </div>

                            <div class="btns flex-all-centered-row">
                                <button @click="setDeleteValidation(false)">
                                    {{ $t(`${localeName}.buttons.cancel`) }}
                                </button>
                                <button @click="handleConfirmDelete()">
                                    {{ $t(`${localeName}.buttons.confirm`) }}
                                </button>
                            </div>
                        </div>
                        <div class="message" v-if="completeValidation">
                            <div class="text">
                                {{ $t(`${localeName}.misc.send_validation`) }}
                            </div>

                            <div class="btns">
                                <button @click="setCompleteValidation(false)">
                                    {{ $t(`${localeName}.buttons.cancel`) }}
                                </button>
                               <button @click="handleConfirmComplete()">
                                    {{ $t(`${localeName}.buttons.confirm`) }}
                               </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="survey-info flex-all-centered-row">
                <div class="left-side flex-all-centered-col">
                    <div class="name flex-all-centered-col">
                        <label for="name">
                            {{ $t(`${localeName}.fields.name`) }}
                        </label>
                        <input type="text" name="name" v-model="surveyDetails.su1_survey_name" @change="_updateSurvey('name')">
                    </div>
                    <div class="desc flex-all-centered-col">
                        <label for="desc">
                            {{ $t(`${localeName}.fields.description`) }}
                        </label>
                        <textarea rows="3" name="desc" v-model="surveyDetails.su1_s_description" @change="_updateSurvey('description')">
                        </textarea>
                    </div>
                </div>

                <div class="right-side flex-all-centered-col">
                    <div class="dates flex-all-centered-row">
                        <div class="created-on flex-all-centered-col">
                            <label for="created-on">
                                {{ $t(`${localeName}.fields.created_on`) }}
                            </label>
                            <div class="created-on">
                                {{ surveyDetails.created_on | dateFormat }}
                            </div>
                        </div>
                        <div class="end-date flex-all-centered-col">
                            <label for="end-date">
                                {{ $t(`${localeName}.fields.end_date`) }}
                            </label>
                            <input type="date" :min="todaysDate" v-model="surveyEndDate" @change="_updateSurvey('date')">
                        </div>
                    </div>
                    <div class="bottom-buttons flex-all-centered-row">
                        <div class="reminder-frequency flex-all-centered-col">
                            <label for="reminder">
                                {{ $t(`${localeName}.fields.reminder_frequency`) }}
                            </label>
                            <div class="reminder" name="reminder">
                                <div class="datalist-labels flex-all-centered-row">
                                    <div v-for="item in reminderOptions" :key="item.val" style="font-size: 10px; font-weight: bold;">
                                        {{ item.text }}
                                    </div>
                                </div>
                                <input type="range" class="form-range" min="3" max="7" step="2" @change="_updateSurvey('reminder_frequency')" v-model="surveyDetails.reminder_frequency_day">
                                <datalist id="customSteps">
                                    <option v-for="item in reminderOptions" :key="item.val" :value="item.val"></option>
                                </datalist>
                            </div>
                        </div>
                        <div class="buttons flex-all-centered-row">
                            <button id="reminder" @click="_sendReminderSU1()" :disabled="sendButtonDisabled" v-if="surveyDetails.is_send">
                                <span v-if="!surveySending">{{ $t(`${localeName}.buttons.reminder`) }}</span>
                                <loading-spinner v-else color="whitesmoke" />
                            </button>

                            <button id="send" @click="_sendSurveySU1()" :disabled="sendButtonDisabled" v-else>
                                <span v-if="!surveySending">{{ $t(`${localeName}.buttons.send`) }}</span>
                                <loading-spinner v-else color="whitesmoke" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="$user.role_id === 1" 
                class="flex-all-centered-row"
                style="align-self: flex-start; justify-self: flex-start; justify-content: flex-start; align-items: center; margin: 1em 0;"
            >
                <input v-model="surveyDetails.is_completed" 
                    @change="_updateSurvey('is_completed')"
                    id="adminIsCompleted" type="checkbox" 
                    style="width: fit-content !important; margin: 0 !important; margin-right: .5em !important;"
                >
                <label for="adminIsCompleted" style="margin: 0 !important;">Is Completed</label>
            </div>
        </div>

        <div v-once
            class="blue-description-bar"
            @click="($event.target.remove())"
            >
            {{ $t(`${localeName}.misc.users_can_access_link`) }}
        </div>

        <div class="loading-wrapper flex-all-centered-col" v-if="!surveyLoading">
            <div class="participations-top-section flex-all-centered-row">
                <div class="participation-info flex-all-centered-row">
                    <div>
                        <b>{{ $t(`${localeName}.stakeholders.total_participation`) }}:</b>&nbsp;{{ surveyParticipationInfo.total_count }}
                    </div>
                    <div>
                        <b>{{ $t(`${localeName}.stakeholders.sent_surveys`) }}:</b>&nbsp;{{ surveyParticipationInfo.sent_count }}
                    </div>
                    <div>
                        <b>{{ $t(`${localeName}.stakeholders.completed_surveys`) }}:</b>&nbsp;{{ surveyParticipationInfo.resolved_count }}
                    </div>
                    <div>
                        <b>{{ $t(`${localeName}.stakeholders.internal_stk`) }}:</b>&nbsp;{{ surveyParticipationInfo.internal_count }} ({{ $t(`${localeName}.stakeholders.completed_by`).replace('#N#', surveyParticipationInfo.internal_resolved_count) }})
                    </div>
                    <div>
                        <b>{{ $t(`${localeName}.stakeholders.external_stk`) }}:</b>&nbsp;{{ surveyParticipationInfo.external_count }} ({{ $t(`${localeName}.stakeholders.completed_by`).replace('#N#', surveyParticipationInfo.external_resolved_count) }})
                    </div>
                </div>

                <button v-if="unsentUserExists" :disabled="sendingToNewUsers" @click="_sendSu1ToNonReceivers()" @keydown.enter="_sendSu1ToNonReceivers()">
                    <span v-if="sendingToNewUsers">
                        {{ $t(`${localeName}.misc.sending`) }}...
                    </span>
                    <span v-else>
                        {{ $t(`${localeName}.buttons.send_to_new`) }}
                    </span>
                </button>

                <button class="export-btn flex-all-centered-row" @click="_downloadSu1Participants()" @keydown.enter="_downloadSu1Participants()">
                    <i class="fa-solid fa-file-export"></i>
                    {{ $t(`${localeName}.buttons.export`) }}
                </button>
            </div>

            <div class="search-wrapper flex-all-centered-row">
                <div class="participant-searchbar flex-all-centered-row">
                    <input type="text" :placeholder="$t(`${localeName}.misc.search_placeholder`)" 
                        v-model="searchKeyword" @keydown.enter="_getSU1Participation()"
                    >
                    <i class="fa-solid fa-magnifying-glass" @click="_getSU1Participation()"></i>
                </div>
                <button type="reset" @click="handleClickReset()" @keydown.enter="handleClickReset()">
                    {{ $t(`${localeName}.buttons.reset`) }}
                </button>
            </div>

            <div class="participations-table flex-all-centered-col">
                <div class="headers flex-all-centered-row">
                    <div class="header flex-all-centered-row" style="width: 2.5%; font-size: .75em;">
                        #
                    </div>
                    <div class="header flex-all-centered-row" v-for="header in participationsHeaders" :key="header.val"
                        :style="{width: header.width}"
                    >
                        <div class="sorter-span flex-all-centered-row" :class="{'sorting-by': sortBy == header.val, 'sortable': header.sortable}" @click="handleClickSorter(header)">
                            <i class="fa-solid fa-circle-info" v-if="header.val == 'receives'" v-b-tooltip.hover.top="{title: $t(`${localeName}.misc.receives_description`)}"></i>
                            {{ header.text }} 
                            <i v-if="sortIncreasing == true && sortBy == header.val" class="fa-solid fa-angle-up"></i>
                            <i v-if="sortIncreasing == false && sortBy == header.val" class="fa-solid fa-angle-down"></i>
                        </div>
                    </div>
                </div>

                <div class="scroll-ctr flex-all-centered-col" ref="scrollContainer" v-if="surveyParticipations.length > 0">
                    <div class="participation flex-all-centered-row" v-for="(item, index) in surveyParticipations" :key="index">
                        <div class="participation-cell flex-all-centered-row" style="width: 2.5%; font-size: .75em;">
                            {{ index + 1 }}
                        </div>
                        <div lang="en" class="participation-cell flex-all-centered-row"
                            :style="{width: participationsHeaders[0].width}"
                        >
                            {{ item.firstname }}
                        </div>
                        <div lang="en" class="participation-cell flex-all-centered-row"
                            :style="{width: participationsHeaders[1].width}"
                        >
                            {{ item.surname }}
                        </div>
                        <div lang="en" class="participation-cell flex-all-centered-row"
                            :style="{width: participationsHeaders[2].width}"
                        >
                            {{ item.email }}
                        </div>
                        <div lang="en" class="participation-cell flex-all-centered-row"
                            :style="{width: participationsHeaders[3].width}"
                        >
                            {{ item.user_department_name }}
                        </div>
                        <div lang="en" class="participation-cell flex-all-centered-row"
                            :style="{width: participationsHeaders[4].width}"
                        >
                            {{ item.role_name }}
                        </div>
                        <div class="participation-cell flex-all-centered-row"
                            :style="{width: participationsHeaders[5].width}"
                            style="justify-content: center;"
                        >
                            <i class="fa-solid fa-xmark"></i>
                            <switch-button :initialValue="item.receive_survey_link" :alignItems="'center'" @buttonState="_updateSU1Participation($event, item)" :disabled="item.is_resolved" />
                            <i class="fa-solid fa-check"></i>
                        </div>
                        <div class="participation-cell flex-all-centered-row"
                            :style="{width: participationsHeaders[6].width}"
                        >
                            <a class="link flex-all-centered-row" :href="item.survey_link" target="_blank"
                                :class="{'uninteractive': item.is_sent == false || item.is_resolved == true}"
                            >
                                <span v-if="item.is_sent">
                                    <span v-if="item.is_resolved">
                                        {{ $t(`${localeName}.stakeholders.completed`) }}
                                    </span>
                                    <span v-else>
                                        {{ $t(`${localeName}.stakeholders.sent`) }}
                                    </span>
                                </span>
                                <span v-else>
                                    {{ $t(`${localeName}.stakeholders.not_sent`) }}
                                </span>
                            </a>
                            <i @click="copyToClipboard(item)" class="fa-solid fa-link"></i>
                        </div>
                    </div>
                </div>
                <div class="no-data-text flex-all-centered-row" v-else>
                    {{ $t('noData.text') }}
                </div>
            </div>
            <div v-if="!loadingParticipants" v-show="!surveyParticipationInfo.fetched_all" class="load-more-participants flex-all-centered-row" @click="handleLoadMore()">
                {{ $t(`${localeName}.buttons.load`) }}
                <i class="fa-solid fa-angle-down"></i>
            </div>
            <div v-else v-show="!surveyParticipationInfo.fetched_all">
                {{ $t(`${localeName}.misc.loading`) }}...
            </div>
        </div>
    </div>
</template>

<style lang='scss' scoped>
    .survey-details-page {
        justify-content: flex-start;
        padding-bottom: 1em;

        > div {
            margin-bottom: 1em;
        }

        > .loading-wrapper {
            justify-content: flex-start;
            padding: 1em;
            background-color: whitesmoke;
            border-radius: 1em;
            box-shadow: 0 .2em .5em .1em gray;
        }
    }

    .top-buttons {
        justify-content: space-between;

        > button {
            padding: .2em .5em .2em .5em;
            min-width: 7.5em;
            border-radius: .5em;
            font-size: 1.1em;
            border: 0;
            box-shadow: 0 .1em .35em .1em gray;

            transition: all 150ms;

            &:hover {
                filter: brightness(115%);
            }

            &:focus {
                outline: thin solid black !important;
            }

            &:active {
                scale: .95;
            }

            color: whitesmoke;
        }

        > #back-btn {
            color: black !important;

            position: relative;
            > i {
                position: absolute;
                left: .25em;
                top: 50%;
                transform: translateY(-50%);
            }
        }

        > .more-btn-ctr {
            position: relative;
            height: 1em;
            z-index: 99;
            
            > #more-btn {
                background-color: transparent;
                color: black;
                font-weight: bold;
                min-width: fit-content !important;
                max-width: fit-content !important;
                padding: .1em .2em !important;
                border-radius: .3em;
                border: 0;
                outline: 0;
                box-shadow: none;

                &:hover {
                    background-color: lightgray;
                }

                &:focus {
                    outline: thin solid black;
                }
            }

            > .actions-list {
                justify-content: flex-start;
                align-items: flex-start;

                background-color: rgb(234, 234, 234);
                color: black;
                box-shadow: 0 .2em .3em .1em gray;
                outline: thin solid lightgray;
                border-radius: .5em;

                position: absolute;
                bottom: 0;
                left: 0;
                transform: translate(-100%, 100%);

                min-width: 200px;

                > .action-item {
                    justify-content: flex-start;
                    padding: .3em .5em .3em .3em;
                    border-bottom: thin solid darkgray;
                    font-weight: bold;

                    transition: all 150ms;
                    cursor: pointer;
                    &:hover, &:focus {
                        background-color: lightgray;
                    }

                    &:last-of-type {
                        border-bottom: 0 !important;
                    }

                    > i {
                        padding-right: .3em;
                    }

                    > .fa-trash-can {
                        color: var(--invalid-input);
                    }

                    > .fa-circle-check {
                        color: rgb(231, 144, 24);
                    }
                }
            }

            > .validation-message {
                padding: .25em .5em .25em .25em;
                width: fit-content;
                min-width: 400px;
                border-radius: .5em;
                border: thin solid lightgray;
                box-shadow: 0 .2em .3em .1em gray;
                background-color: whitesmoke !important;

                position: absolute;
                bottom: 0;
                left: 0;
                transform: translate(-100%, 100%);

                > .message {
                    align-items: flex-start;

                    > .text {
                        font-weight: bold;
                    }

                    > .btns {
                        margin-top: .5em;
                        justify-content: flex-end;

                        button {
                            color: whitesmoke;
                            border-radius: .3em;
                            outline: thin solid lighgray;
                            border: 0;
                            padding: .25em .5em;

                            &:first-of-type {
                                margin-right: .5em;
                                background-color: var(--invalid-input);

                                &:hover {
                                    background-color: rgb(204, 58, 0);
                                }
                            }

                            &:nth-of-type(2) {
                                background-color: var(--sustainfinity-green);

                                &:hover {
                                    background-color: #3c9600;
                                }
                            }
                        }
                    }
                }
            }
        }

        > button:disabled {
            background-color: darkgray !important;
            pointer-events: none !important;
        }
    }

    .survey-info {
        margin-top: 1em;
        justify-content: flex-start;
        align-items: flex-start;

        > .left-side {
            justify-content: flex-start;
            max-width: 40%;

            > .name, .desc {
                justify-content: flex-start;
                align-items: flex-start;
            }
        }

        > .right-side {
            padding-left: 2em;
            justify-content: flex-start;
            align-items: flex-start;

            > .dates {
                justify-content: flex-start;
                
                > .created-on, .end-date {
                    justify-content: flex-start;
                    align-items: flex-start;

                    > .label {
                        font-weight: bold;
                        justify-content: flex-start;
                        text-align: left;
                        color: var(--sustainfinity-navy);
                        font-size: 1.1em
                    }
                }
            }

            > .bottom-buttons {
                justify-content: flex-start;

                > .buttons {
                    justify-content: flex-start;

                    > button {
                        border-radius: .3em;
                        border: 0;
                        outline: 0;
                        color: whitesmoke;
                        padding: .25em .5em;
                        box-shadow: 0 .1em .5em .01em gray;

                        transition: all 200ms;
                        &:focus {
                            outline: thin solid lightgray;
                        }

                        &:active {
                            outline: thin solid darkgray;
                            scale: .95;
                        }
                    }

                    > #reminder {
                        background-color: var(--sustainfinity-blue);

                        &:hover {
                            background-color: rgb(0, 105, 175);
                        }
                    }

                    > #send {
                        background-color: var(--sustainfinity-green);

                        &:hover {
                            background-color: #3c9600;
                        }
                    }
                }
            }
        }
    }

    .reminder-frequency {
        justify-content: flex-start;
        align-items: flex-start;
        
        > .reminder {
            width: 70%;
            margin-top: 1em;

            > .datalist-labels {
                justify-content: space-between;
            }
        }
    }

    .participations-top-section {
        justify-content: space-between;

        > .participation-info {
            width: 60%;
            justify-content: flex-start;

            > div {
                margin-right: 1em;

                > b {
                    font-size: 1.1em;
                    color: var(--sustainfinity-navy);
                }
            }
        }

        > button {
            border: 0;
            outline: 0;
            border-radius: .5em;
            background-color: var(--sustainfinity-blue);
            color: whitesmoke;
            padding: .3em .5em .3em .5em;
            box-shadow: 0 .1em .3em .1em gray;

            transition: all 150ms;
            &:hover {
                background-color: rgb(0, 105, 175);
            }
        }
    }

    .participations-table {
        justify-content: flex-start;
        border-radius: 1em;
        overflow: hidden;

        font-size: .7vw;

        > .headers {
            background-color: var(--sustainfinity-navy);
            color: whitesmoke;
            text-align: center;
            padding: .75em 0 .75em 0;

            > .header {
                justify-content: flex-start;
                border-right: whitesmoke !important;

                &:last-of-type {
                    justify-content: flex-end;
                    padding-right: .5em;

                    > .sorter-span {
                        justify-content: flex-end;
                    }
                }

                &:nth-of-type(7) {
                    justify-content: center;

                    > .sorter-span {
                        justify-content: center;

                        > .fa-circle-info {
                            cursor: help;
                            padding-right: .2em;
                            padding-left: 0;
                        }
                    }
                }

                > .sorter-span {
                    justify-content: flex-start;

                    > i {
                        padding-left: .2em;
                        transform: translateY(10%);
                    }
                }

                > .sortable {
                    cursor: pointer;
                    &:hover {
                        text-decoration: underline;
                    }
                }

                > .sorting-by {
                    text-decoration: underline;
                }
            }
        }

        > .scroll-ctr {
            justify-content: flex-start;
            overflow-y: scroll;
            
            > .participation {
                background-color: rgb(240, 240, 240);
                color: var(--sustainfinity-navy);
                border-bottom: thin solid lightgray;
                text-align: center;
                padding: .75em 0 .75em 0;
                &:last-of-type {
                    border-bottom: 0 !important;
                }

                > .participation-cell {
                    justify-content: flex-start;
                    text-align: left;
                    word-break: break-word;
                    hyphens: auto;
                    -ms-hyphens: auto;
                    -moz-hyphens: auto;
                    -webkit-hyphens: auto;

                    > i {
                        color: var(--sustainfinity-blue);
                        padding-left: .5em;
                        
                        transition: all 150ms;
                        cursor: pointer;
                        &:hover {
                            color: var(--sustainfinity-navy);
                        }
                    }

                    > .fa-check {
                        padding: 0;
                        padding-left: .4em;
                        color: var(--sustainfinity-green);
                        pointer-events: none;
                    }

                    > .fa-xmark {
                        padding: 0;
                        padding-right: .4em;
                        color: var(--invalid-input);
                        pointer-events: none;
                    }
                }

                > .participation-cell > .link {
                    justify-content: flex-end;
                    padding-right: .25em;
                    color: var(--sustainfinity-blue);
                    > .fa-link {
                        padding-right: .25em;
                        transform: translateY(10%);
                    }

                    &:hover {
                        color: var(--sustainfinity-green);
                    }
                }
            }
        }

        > .no-data-text {
            font-size: 1.5em;
            font-weight: bold;
            padding-top: .5em;
        }
    }

    .load-more-participants {
        padding: .5em;
        margin-top: 1em;
        font-weight: bold;

        transition: all 150ms;
        cursor: pointer;
        &:hover {
            background-color: lightgray;
        }

        > i {
            padding-left: .5em;
        }
    }

    label {
        font-weight: bold;
        margin: 1em 0 0 0 !important;
        line-height: 1.5em;
        color: var(--sustainfinity-navy);
        font-size: 1.1em;
    }

    input {
        background: 0;
        outline: 0;
        border: 0;
        border-bottom: thin solid lightgray;
        width: 100%;

        &:focus {
            border-bottom: thin solid black;
        }
    }

    textarea {
        background: 0;
        outline: thin solid lightgray;
        border: 0;
        width: 100%;
        min-height: 1.5em;

        &:focus {
            outline: thin solid black;
        }
    }

    .export-btn {
        width: fit-content !important;
        padding: .5em 1em !important;
        background-color: var(--sustainfinity-navy) !important;

        &:hover {
            background-color: #073c56 !important;
        }

        &:focus {
            background-color: #073c56 !important;
        }

        > i {
            padding-right: .5em;
        }
    }

    // reminder frequency slider //
    input[type="range"] {
        -webkit-appearance: none;
        appearance: none;
        background: transparent;
        cursor: pointer;
    }

    input[type="range"]::-webkit-slider-runnable-track {
        background: gray;
        height: 0.1rem;
    }

    input[type="range"]::-moz-range-track {
        background: gray;
        height: 0.1rem;
    }

    input[type="range"]::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        margin-top: -12px;
        background-color: #ffffff;
        border: thin solid black;
        border-radius: 50%;
        height: .5rem;
        width: .5rem;
        margin-top: -.2rem;
    }

    // search //

    .search-wrapper {
        margin-bottom: 2em;
        justify-content: flex-start;
        width: 100%;

        > .participant-searchbar {
            justify-content: flex-start;
            width: 50%;

            > input {
                width: 100%;
                background-color: white !important;
                background: 0;
                border: 0;
                outline: thin solid lightgray;
                border-radius: 100px;
                padding: .5em 2.5em .5em 1em;

                &:focus {
                    outline: thin solid gray !important;
                }

                &::placeholder {
                    color: lightgray;
                }
            }

            position: relative;
            > i {
                position: absolute;
                right: 1em;
                top: 50%;
                transform: translateY(-35%);
                font-size: .9em;

                transform-origin: 50% 50%;

                transition: all 150ms;
                cursor: pointer;
                &:hover {
                    scale: 1.15;
                }
            }
        }

        > button {
            margin-left: .5em;
            background-color: whitesmoke;
            border: 0;
            outline: thin solid lightgray;
            padding: .5em 1em .5em 1em;
            border-radius: .5em;
            transition: all 150ms;

            &:focus {
                outline: thin solid gray !important;
            }

            &:active {
                scale: .95;
            }
            
            &:hover {
                background-color: white;
            }
        }
    }

    //

    .uninteractive {
        color: gray !important;
        pointer-events: none !important;
        cursor: default !important;
        text-decoration: none !important;
    }

    #reminder:disabled {
        background-color: gray !important;
        cursor: not-allowed;
        opacity: 0.6;
    }

</style>